module.exports = __webpack_public_path__ + "assets/img/budapark5-640.75a4f1b0.webp";